import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import ManualClassroomsProvider from 'containers/App/context/ClassroomsContext/ManualClassroomsContext';
import FakeUserProvider from 'containers/App/context/FakeUserProvider';
import { FakeSchoolSchoolyearProvider } from 'containers/App/context/FakeSchoolSchoolyearProvider';
import { useGetShareLivret } from 'containers/Livrets/LivretEvalShare/useGetShareLivret';
import { useLivretEval } from 'containers/Livrets/queries/useLivretEval';
import { Contact, School } from 'types/school';
import { Eleve } from 'types/eleves';
import { Classroom } from 'types/classroom';
import { Schoolyear } from 'types/schoolyear';
import { Bo } from 'types/bo';
import { Periode } from '../types/livret';
import ScreenSpinner from 'components/Spinner/ScreenSpinner';
import { ErrorPage } from 'components/ErrorPage';
import { NotFoundPage } from 'components/ErrorPage/NotFoundPage';

interface Props {
  school: School;
  eleves: Eleve[];
  classroom: Classroom;
  schoolyear: Schoolyear;
  directors: Contact[];
  bo: Bo;
  userId: string;
  token: string;
  periodes: Periode[];
  livretEvalId: string;
  readonly?: boolean;
}

function LivretEvalShare(props: Props) {
  const {
    school,
    eleves,
    classroom,
    schoolyear,
    directors,
    bo,
    userId,
    token,
    periodes,
    livretEvalId,
    readonly,
  } = props;
  const { data, isLoading } = useLivretEval({ livretEvalId });
  if (isLoading || !data) return <ScreenSpinner />;
  return (
    <Outlet
      context={{
        livretEval: data,
        eleves: eleves,
        classroom: classroom,
        school: school,
        schoolyear: schoolyear,
        directors: directors,
        bo: bo,
        userId: userId,
        token: token,
        periodes: periodes,
        readonly: readonly,
      }}
    />
  );
}

export function LivretEvalShareWrapper() {
  const params = useParams<{
    token: string;
    userId: string;
  }>();
  const userId = params.userId as string;
  const token = params.token as string;
  const { data, isLoading, error } = useGetShareLivret(userId, token);
  if (error) {
    if ((error as any)?.response?.status === 404) {
      return <NotFoundPage toHome />;
    }
    return <ErrorPage />;
  }
  if (isLoading || !data) return <ScreenSpinner />;
  return (
    <FakeUserProvider user={{ id: userId, isNotLoggedIn: true }}>
      <FakeSchoolSchoolyearProvider
        schoolyear={data.schoolyear}
        school={data.school}
      >
        <ManualClassroomsProvider
          classrooms={data?.classroom ? [data?.classroom] : []}
        >
          <LivretEvalShare
            readonly={data.readonly}
            school={data.school}
            eleves={data.eleves}
            classroom={data.classroom}
            schoolyear={data.schoolyear}
            directors={data.directors}
            bo={data.bo}
            userId={userId}
            token={token}
            periodes={data.periodes}
            livretEvalId={data.livretEval.id}
          />
        </ManualClassroomsProvider>
      </FakeSchoolSchoolyearProvider>
    </FakeUserProvider>
  );
}
